import { useRef, useState } from "react";
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
import { HelpModalOptions } from "./HelpModalOptions";
import { useUserState } from "../../../../contexts/user.context";
import { useOutsideClickDetection } from "../../../../hooks/useOutsideClickDetection";

export function Help() {
  const user = useUserState();
  const [openHelpOptions, setOpenHelpOptions] = useState(false);
  const helpOptionsRef = useRef<HTMLDivElement>(null!);
  useOutsideClickDetection(helpOptionsRef, openHelpOptions, setOpenHelpOptions);

  return (
    <>
      {user.teamId !== "pi6j" && (
        <>
          <ComponentLibrary.PCIconButton icon={"question"} title={"Help"} clickHandler={() => setOpenHelpOptions(!openHelpOptions)} utilityClasses={"bg-pink white b--solid bw1 b--white shadow-light"} inlineStyles={{ height: "65px", width: "65px", borderRadius: "50%", zIndex: "2", position: "fixed", bottom: "30px", right: "30px", outline: "0.2vw solid #f8506f" }} size={"2x"} pulse={true} />
          <HelpModalOptions innerRef={helpOptionsRef} openHelpOptions={openHelpOptions} />
        </>
      )}
    </>
  );
}
